var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1824_6986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8774 4.41569L8.13478 7.15828L5.39218 4.41569L4.68506 5.12278L7.42768 7.86538L4.68506 10.608L5.39218 11.3151L8.13478 8.5725L10.8774 11.3151L11.5845 10.608L8.84187 7.86538L11.5845 5.12278L10.8774 4.41569Z",
    fill: "#A7ADB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3033 2.69669C11.8968 1.29016 9.98914 0.499984 8.00002 0.499984C6.01089 0.499984 4.10323 1.29016 2.6967 2.69669C1.29018 4.10321 0.5 6.01087 0.5 8C0.5 9.98913 1.29018 11.8968 2.6967 13.3033C4.10323 14.7098 6.01089 15.5 8.00002 15.5C9.98914 15.5 11.8968 14.7098 13.3033 13.3033C14.7099 11.8968 15.5 9.98913 15.5 8C15.5 6.01087 14.7099 4.10321 13.3033 2.69669ZM8.00002 14.5C4.41592 14.5 1.50002 11.5841 1.50002 8C1.50002 4.41591 4.41592 1.5 8.00002 1.5C11.5841 1.5 14.5 4.41591 14.5 8C14.5 11.5841 11.5841 14.5 8.00002 14.5Z",
    fill: "#A7ADB8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1824_6986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ceeb93c5469f3da556a313fd402a7dea.svg";
export { ForwardRef as ReactComponent };